import theme from '@/constants/theme';

export const styles: Record<string, React.CSSProperties> = {
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: 8,
    backgroundColor: theme.colors.background.secondary,
    borderRadius: 16,
    width: '100%',
  },
  disableOptions: {
    overflow: 'hidden',
    pointerEvents: 'none',
    userSelect: 'none',
    opacity: 0.5,
  },
  audioCover: {
    borderRadius: 8,
    backgroundColor: theme.colors.background.primary,
    // opacity: 0.5,
    width: 'auto',
    flex: 1,
    position: 'relative',
    maxWidth: '100%',
    display: 'flex',
  },
  audioTrackIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 200,
    height: 200,
    color: theme.colors.text.caption,
    opacity: 0.5,
  },
  text: {
    color: 'white',
    marginBottom: 10,
  },
  controls: {
    gap: 8,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'inherit',
    padding: 16,
    minHeight: 160,
  },
  timeIndicator: {
    color: theme.colors.text.caption,
    marginBottom: 8,
    width: 100,
    textAlign: 'center',
  },
  emptySlider: {
    backgroundColor: theme.colors.background.primary,
    height: 2,
    borderRadius: 4,
  },
  playerOptions: {
    gap: 16,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: 'inherit',
    alignItems: 'center',
  },
  controlsOptions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: 'inherit',
    alignItems: 'center',
    marginBottom: 16,
  },
  volumeOptions: {
    gap: 16,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: theme.colors.background.primary,
    color: theme.colors.text.default,
    padding: 16,
    borderRadius: 8,
  },
  button: {
    paddingTop: 10,
    paddingBottom: 10,
    color: theme.colors.text.title,
    backgroundColor: 'inherit',
    border: 'none',
  },
  playButton: {
    padding: 10,
    borderRadius: 360,
    backgroundColor: 'white',
    border: 'none',
  },
  progressBar: {
    marginBottom: 16,
  },
  slider: {
    flex: 1,
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 160,
  },
  loader: {
    marginTop: 16,
    color: theme.colors.primary,
    width: 42,
    height: 42,
  },
};
